import { useSnapshot } from "valtio";

import React from "react";
import { useTranslation } from "react-i18next";

import { syncStore } from "@components/Synchronization/store";

import "./LoadingScreen.css";

const LoadingScreen: React.FC = React.memo(() => {
    const { t } = useTranslation();
    const { selectedEntityChild } = useSnapshot(syncStore);

    const { logoText, primaryColor, secondaryColor } = {
        logoText: selectedEntityChild?.name || "KIOSK",
        primaryColor: "var(--global-color)",
        secondaryColor: "var(--secondary-color)",
    };

    // Dynamic styles for spinner rings
    const ring1Style: React.CSSProperties = {
        borderTopColor: primaryColor,
        borderRightColor: primaryColor,
    };

    const ring2Style: React.CSSProperties = {
        borderTopColor: secondaryColor,
        borderRightColor: secondaryColor,
    };

    const progressStyle: React.CSSProperties = {
        background: primaryColor,
    };

    return (
        <div className="kiosk-loading-screen-container">
            {/* Logo Text */}
            <div className="kiosk-loading-logo-container">
                <div className="kiosk-loading-logo-text">{logoText}</div>
            </div>

            {/* Spinner */}
            <div className="kiosk-loading-spinner-container">
                <div
                    className="kiosk-loading-spinner-ring kiosk-loading-ring-1"
                    style={ring1Style}
                />
                <div
                    className="kiosk-loading-spinner-ring kiosk-loading-ring-2"
                    style={ring2Style}
                />
                <div className="kiosk-loading-spinner-center">
                    <div className="kiosk-loading-center-icon">🍽️</div>
                </div>
            </div>

            {/* Messages */}
            <div className="kiosk-loading-message-container">
                <div className="kiosk-loading-main-message">
                    {t("Your order is being processed")}
                    <span className="kiosk-loading-dots">
                        <span>.</span>
                        <span>.</span>
                        <span>.</span>
                    </span>
                </div>
                <div className="kiosk-loading-sub-message">
                    {t("Please wait a moment")}
                </div>

                {/* Progress Bar */}
                <div className="kiosk-loading-progress-bar">
                    <div
                        className="kiosk-loading-progress-fill"
                        style={progressStyle}
                    />
                </div>

                <div className="kiosk-loading-info-text">
                    {t("Your order will be ready soon")}
                </div>
            </div>
        </div>
    );
});

LoadingScreen.displayName = "LoadingScreen";

export default LoadingScreen;
